import { render } from "./Spinner.vue?vue&type=template&id=52997df4&ts=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=52997df4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__